import React from 'react';

const ANZLogo = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width="130"
      height="50"
      viewBox="0 0 130 50"
      xmlSpace="preserve"
      { ...props }
    >
      <desc>Created with Fabric.js 4.6.0</desc>
      <defs/>
      <g transform="matrix(0.16 0 0 0.16 105.84 25)" id="8AU7ZBVqjibTFe50eyOsL">
        <path
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'rgb(256, 256, 256)',
            fillRule: 'nonzero',
            opacity: 1,
          }}
          vectorEffect="non-scaling-stroke"
          transform="translate(-641.89, -121.8)"
          d="M 641.9 71.6 C 653.4 71.6 666.4 81.5 666.5 95.1 C 666.5 102.8 664 108.69999999999999 660.4 114.1 C 658 117.6 656.1999999999999 121.6 655.5 124.5 C 654.7 127.8 653 135.6 662.7 135.8 C 669 135.9 684.5 130.5 697.1 115.4 C 706.7 103.30000000000001 712.5 88 712.5 71.4 C 712.5 32.400000000000006 680.9 0.8000000000000114 641.9 0.8000000000000114 C 602.9 0.8000000000000114 571.3 32.40000000000001 571.3 71.4 C 571.3 88.10000000000001 577 103.4 586.6999999999999 115.4 C 599.1999999999999 130.4 614.8 135.9 621.0999999999999 135.8 C 630.8 135.60000000000002 629.0999999999999 127.80000000000001 628.3 124.50000000000001 C 627.5999999999999 121.60000000000001 625.8 117.70000000000002 623.5 114.10000000000001 C 619.9 108.7 617.4 102.80000000000001 617.4 95.10000000000001 C 617.4 81.50000000000001 630.4 71.60000000000001 641.9 71.60000000000001 z M 766.6999999999999 142.89999999999998 C 763.8 140.49999999999997 758.6999999999999 136.99999999999997 748.3 135.49999999999997 C 733.9 133.29999999999998 721 136.69999999999996 713.1999999999999 139.79999999999998 C 702.9999999999999 143.79999999999998 690.4 152.89999999999998 681.6999999999999 164.79999999999998 C 672.5999999999999 177.29999999999998 667.8 196.29999999999998 672.3 216 C 673.5999999999999 221.6 675 224.7 677 228.6 C 679.8 233.9 686.9 241.29999999999998 693.2 242.6 C 698.2 243.6 702 240.79999999999998 703.9000000000001 238.6 C 716.5000000000001 224.1 764.4000000000001 167.89999999999998 769.5000000000001 160.7 C 774.7000000000002 153.6 771.4000000000001 146.79999999999998 766.7000000000002 142.89999999999998 z M 570.5999999999999 139.79999999999998 C 562.8 136.7 549.8999999999999 133.29999999999998 535.4999999999999 135.49999999999997 C 525.0999999999999 137.09999999999997 519.9999999999999 140.59999999999997 517.0999999999999 142.89999999999998 C 512.3999999999999 146.79999999999998 509.0999999999999 153.59999999999997 514.1999999999999 160.7 C 519.4 167.89999999999998 567.1999999999999 224.1 579.8 238.6 C 581.5999999999999 240.7 585.5 243.6 590.5 242.6 C 596.8 241.29999999999998 603.9 233.9 606.7 228.6 C 608.7 224.7 610.1 221.6 611.4000000000001 216 C 616.0000000000001 196.3 611.2 177.3 602.0000000000001 164.8 C 593.4000000000001 152.9 580.8000000000001 143.8 570.6000000000001 139.8"
        />
      </g>
      <g
        transform="matrix(0.16 0 0 0.16 71.07 23.08)"
        id="2Bm30i-e3_8gxCDJJXuWy"
      >
        <path
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'rgb(256, 256, 256)',
            fillRule: 'evenodd',
            opacity: 1,
          }}
          vectorEffect="non-scaling-stroke"
          transform="translate(-424.2, -38.8)"
          d="M 363.1 45.5 L 419.3 45.5 C 419.3 45.5 407.7 60.6 395.1 77.1 L 460.6 77.1 C 472.3 61.9 482.9 48 484.5 45.9 C 491.9 36.3 493.6 27.6 493.6 20 L 493.6 9.1 C 493.6 3.5999999999999996 490.20000000000005 0.5 485 0.5 L 363.2 0.5 C 358.2 0.5 354.8 3.2 354.8 8.9 L 354.8 37 C 354.7 42.7 358 45.5 363.1 45.5 z"
          strokeLinecap="round"
        />
      </g>
      <g
        transform="matrix(0.16 0 0 0.16 11.54 37.14)"
        id="agj4xTZKoVSL2yWzLLikH"
      >
        <path
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'rgb(256, 256, 256)',
            fillRule: 'evenodd',
            opacity: 1,
          }}
          vectorEffect="non-scaling-stroke"
          transform="translate(-51.44, -126.85)"
          d="M 1.3 154.8 C -0.19999999999999996 157.4 -0.19999999999999996 160.10000000000002 0.7000000000000001 161.9 C 1.8000000000000003 164 4.2 165.1 6.8 165.1 L 46.699999999999996 165.1 C 51.8 165.1 56.199999999999996 162.4 58.8 158.4 L 102.8 88.60000000000001 L 43.1 88.60000000000001 C 22.4 121.2 1.7 154 1.3 154.8 Z"
          strokeLinecap="round"
        />
      </g>
      <g
        transform="matrix(0.16 0 0 0.16 26.22 37.14)"
        id="474C4zZpJpABbVLeerW6U"
      >
        <path
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'rgb(256, 256, 256)',
            fillRule: 'evenodd',
            opacity: 1,
          }}
          vectorEffect="non-scaling-stroke"
          transform="translate(-143.35, -126.85)"
          d="M 165.2 88.6 L 109.39999999999999 88.6 C 110.8 96.3 121.1 153.89999999999998 121.69999999999999 157.3 C 122.6 162.5 125.89999999999999 165.10000000000002 130.7 165.10000000000002 L 169.1 165.10000000000002 C 172.6 165.10000000000002 174.4 164.00000000000003 176 162.00000000000003 C 177.1 160.60000000000002 177.6 158.50000000000003 177.1 155.40000000000003 z"
          strokeLinecap="round"
        />
      </g>
      <g
        transform="matrix(0.16 0 0 0.16 45.5 30.12)"
        id="G74RlzJ9fotWahPDT5gqp"
      >
        <path
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'rgb(256, 256, 256)',
            fillRule: 'evenodd',
            opacity: 1,
          }}
          vectorEffect="non-scaling-stroke"
          transform="translate(-264.1, -82.85)"
          d="M 337.2 9 C 337.2 3.4 333.8 0.6 328.8 0.6 L 294.8 0.6 C 289.8 0.6 286.4 3.3 286.4 9 L 286.4 72.8 L 254.2 15.4 C 247.8 4.8 237 0.9 224.4 0.6 L 199.3 0.6 C 194.3 0.6 190.9 3.3 190.9 9 L 190.9 77.2 L 233 77.2 L 239.4 88.6 L 191 88.6 L 191 156.7 C 191 162.3 194.4 165.1 199.4 165.1 L 233.4 165.1 C 238.4 165.1 241.8 162.4 241.8 156.7 L 241.8 92.5 L 274.2 150.3 C 280.5 160.8 291.4 164.8 304 165.1 L 328.9 165.1 C 333.9 165.1 337.3 162.4 337.3 156.7 L 337.3 88.6 L 295.4 88.6 L 289 77.2 L 337.3 77.2 z"
          strokeLinecap="round"
        />
      </g>
      <g
        transform="matrix(0.16 0 0 0.16 20.36 23.1)"
        id="lEMhUP1IL87Dw3NDYUUrH"
      >
        <path
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'rgb(256, 256, 256)',
            fillRule: 'evenodd',
            opacity: 1,
          }}
          vectorEffect="non-scaling-stroke"
          transform="translate(-106.65, -38.9)"
          d="M 151 8.5 C 150 3.1 146.5 0.6 141.7 0.6 L 125 0.6 C 107.6 0.6 92.4 9.7 83.8 23.5 C 83.8 23.5 67.9 48.8 50.1 77.2 L 163.2 77.2 z"
          strokeLinecap="round"
        />
      </g>
      <g
        transform="matrix(0.16 0 0 0.16 71.06 37.15)"
        id="em5Ri-LcF_H_kkPAyclJ8"
      >
        <path
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'rgb(256, 256, 256)',
            fillRule: 'evenodd',
            opacity: 1,
          }}
          vectorEffect="non-scaling-stroke"
          transform="translate(-424.1, -126.9)"
          d="M 486.5 120.2 L 427.5 120.2 C 427.5 120.2 439 105.2 451.7 88.6 L 386.2 88.6 C 374.3 104.19999999999999 363.5 118.19999999999999 362.9 119 C 354.2 131.1 353.29999999999995 143.3 353.29999999999995 151.8 C 353.29999999999995 153.60000000000002 353.29999999999995 156.60000000000002 353.29999999999995 156.60000000000002 C 353.29999999999995 162.10000000000002 356.69999999999993 165.20000000000002 361.9 165.20000000000002 L 486.5 165.20000000000002 C 491.5 165.20000000000002 494.9 162.50000000000003 494.9 156.8 L 494.9 128.70000000000002 C 494.9 122.90000000000002 491.5 120.20000000000002 486.5 120.20000000000002 z"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export { ANZLogo };
